/**
 * Sidebar live-count badge for pending elevation approvals.
 *
 * Polls ``GET /api/platform-access/approvals/pending-count`` every
 * 15 s. Hidden if:
 *   - the caller is not an approver (403 response) — badge stays 0/invisible;
 *   - there are zero pending approvals.
 */
import React, { useEffect, useState } from 'react';
import api from '../services/api';

const POLL_MS = 15000;

export const ApprovalsBadge = () => {
  const [count, setCount] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    let alive = true;

    const fetchCount = async () => {
      try {
        const { data } = await api.get('/platform-access/approvals/pending-count');
        if (!alive) return;
        setCount(data?.count || 0);
        setVisible(true);
      } catch (e) {
        // 403 means the caller isn't an approver — hide badge silently.
        if (!alive) return;
        if (e?.response?.status === 403) {
          setVisible(false);
        } else {
          // network / transient — keep prior count, don't flash zero.
        }
      }
    };

    fetchCount();
    const t = setInterval(fetchCount, POLL_MS);
    return () => {
      alive = false;
      clearInterval(t);
    };
  }, []);

  if (!visible || count <= 0) return null;

  return (
    <span
      className="ml-auto inline-flex items-center justify-center rounded-full bg-red-600 text-white text-[10px] font-bold min-w-[18px] h-[18px] px-1"
      data-testid="approvals-pending-badge"
      aria-label={`${count} pending elevation approvals`}
    >
      {count > 99 ? '99+' : count}
    </span>
  );
};
